import { makeStyles } from "@material-ui/styles"

const styles = makeStyles(theme => ({
  tagContainer: {
    height: 300,
    overflow: "auto"
  },
  tagContent: {
    "&:first-child": {
      paddingTop: 0,
      paddingLeft: 0,
      paddingRight: 0,
      marginLeft: 0,
      marginRight: 0
    },
    display: "flex",
    justifyContent: "flex-start",
    flexWrap: "wrap"
  },
  tag: {
    margin: theme.spacing(1, 1),
    marginLeft: 0,
    backgroundColor: "#ADB4FF"
  },
  deleteLoading: {
    marginRight: 10,
    marginLeft: -5
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/pages/Admin/pages/Communication/CommunicationEmail/ManageTagsDialog/ManageTags/styles.js